import styled from 'styled-components';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaQuestionCircle } from 'react-icons/fa';
import React from 'react';
import { AboutIcon } from './Navbar';

const FooterContainer = styled.footer`
  background-color: #1d3557;
  color: white;
  padding: 50px 20px 20px;
  width: 100%;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
`;

const FooterSection = styled.div`
  @media (max-width: 768px) {
    text-align: center;
  }
`;

const Title = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 20px;
  color: #fff;
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
`;

const ListItem = styled.li`
  margin-bottom: 10px;
  
  a {
    color: #fff;
    text-decoration: none;
    transition: color 0.3s ease;
    
    &:hover {
      color: #e63946;
    }
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 20px;
  
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const SocialIcon = styled.a`
  color: white;
  font-size: 24px;
  transition: color 0.3s ease;
  
  &:hover {
    color: #e63946;
  }
`;

const Copyright = styled.div`
  text-align: center;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <Title>À propos</Title>
          <List>
            <ListItem>
              <a href="/about">Notre histoire</a>
            </ListItem>
            <ListItem>
              <a href="/about">Notre équipe</a>
            </ListItem>
            <ListItem>
              <a href="/about">Carrières</a>
            </ListItem>
          </List>
        </FooterSection>

        <FooterSection>
          <Title>Services</Title>
          <List>
            <ListItem>
              <a >
              

                Nos produits</a>
            </ListItem>
            <ListItem>
              <a href="#delivery">Livraison</a>
            </ListItem>
            <ListItem>
              <a href="#support">Support</a>
            </ListItem>
          </List>
        </FooterSection>

        <FooterSection>
          <Title>Contact</Title>
          <List>
            <ListItem>contact@malambabusiness.com</ListItem>
            <ListItem>Tél: +243 994 999 555</ListItem>
            <ListItem>Tél: +243 850 269 000</ListItem>
            <ListItem>Adresse: KINSHASA, RD CONGO</ListItem>
          </List>
          <SocialIcons>
            <SocialIcon href="https://web.facebook.com/profile.php?id=61558056526449&sk=photos_by"><FaFacebook /></SocialIcon>
            <SocialIcon href="https://x.com/Malambabusiness"><FaTwitter /></SocialIcon>
            <SocialIcon href="#"><FaInstagram /></SocialIcon>
            <SocialIcon href="https://www.linkedin.com/company/new-malamba-business/"><FaLinkedin /></SocialIcon>
          </SocialIcons>
        </FooterSection>
      </FooterContent>
      <Copyright>
        © {new Date().getFullYear()} New Malamba Business. Tous droits réservés.
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;